import { AvailableWinDisplayProperties } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/properties/AvailableWinDisplayProperties";
/**
 * AvailableWinDisplayLandscapeProperties.ts
 */
export class AvailableWinDisplayLandscapeProperties extends AvailableWinDisplayProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.availableWinTextHolderPosition.set(952, 410);
        this.availableWinTextHolderScale.set(0.86);
    }
}
